import axios from 'axios'
import { apiClient } from './axios.config'

// The deploy flow (`cam deploy staging --maintenance`) parks the ALB on a 503
// fixed-response carrying `{ maintenance: true }` while it migrates + rolls. The
// SPA detects that response and shows a maintenance screen instead of a wall of
// error toasts, then auto-recovers once the API answers again.

const MAINTENANCE_EVENT = 'app:maintenance'

const isMaintenanceError = (error: unknown): boolean => {
  const response = (
    error as { response?: { status?: number; data?: { maintenance?: boolean } } }
  )?.response
  return response?.status === 503 && Boolean(response?.data?.maintenance)
}

const emitMaintenance = () =>
  window.dispatchEvent(new CustomEvent(MAINTENANCE_EVENT))

// Subscribe to maintenance-mode activation; returns an unsubscribe fn.
export const onMaintenance = (cb: () => void): (() => void) => {
  window.addEventListener(MAINTENANCE_EVENT, cb)
  return () => window.removeEventListener(MAINTENANCE_EVENT, cb)
}

// Register on BOTH the shared apiClient and the bare axios default — the helpers
// in axios.helpers.ts call axios.* directly — so any 503 maintenance response
// from anywhere flips the app into the maintenance screen. Call once at boot.
export const setupMaintenanceInterceptor = () => {
  const onRejected = (error: unknown) => {
    if (isMaintenanceError(error)) emitMaintenance()
    return Promise.reject(error)
  }
  axios.interceptors.response.use((r) => r, onRejected)
  apiClient.interceptors.response.use((r) => r, onRejected)
}
